export class SkillFilters {
    searchSkill: any = '';
    searchByParentSkill: any = '';
    searchCategory: any = '';
    sortColumn: any = 'skill';
    sortDir: any = 'ASC';
    includeAlternateSkills: boolean = false;
}